<template lang="pug">
  .flex
    v-circle.mr-2(:color="info.color")
    span {{ info.title | translate }}
</template>

<script>
import { COLORS } from '@/util/consts.js'

export default {
  name: 'ActionType',

  computed: {
    info () {
      if (this.$slots.default && this.$slots.default[0]) {
        switch (this.$slots.default[0].text) {
          case '+':
            return {
              title: 'base.creation',
              color: COLORS.GREEN
            }
          case '-':
            return {
              title: 'base.removal',
              color: COLORS.RED
            }
          case '~':
            return {
              title: 'base.editing',
              color: COLORS.ORANGE
            }
          default:
            return {}
        }
      }
    }
  }
}
</script>
